'use strict';

var ngModule = 'frontend.salary';

require('angular')
  .module(ngModule, [
    require('./salary-invite')
  ])
  // @deprecated, use salaryService
  .factory('salaryQuestionnaireService', require('./service/salary-questionnaire'))
  .factory('salaryQuestionnaireAnswerService', require('./service/salary-questionnaire-answer'))
  //
  .factory('salaryService', require('./service/salary'))
  .component('salaryIntro', require('./salary-intro'))
  .component('salaryQuestionnaire', require('./salary-questionnaire'))
  .component('salarySummary', require('./salary-summary'))
  .component('salaryRound', require('./salary-round'))
  .component('salaryBasis', require('./salary-basis'))
  .component('salaryNavigation', require('./salary-navigation'))
  .component('salaryDistribution', require('./salary-distribution'))
  .component('salaryOverview', require('./salary-overview'));

module.exports = ngModule;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/index.js
 ** module id = 192
 ** module chunks = 0
 **/